import store from '../../store'
import { SET_APP_BUSY } from '../app'

/**
 * Set app busy action
 * @param {boolean} busy
 */
export const setAppBusyAction = busy => (
    store.dispatch({
        type: SET_APP_BUSY,
        busy: busy,
    })
)
